import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/404.png'


const _withScopeId = n => (_pushScopeId("data-v-3c14e90a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error404" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error404-content main-center cross-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLayoutFooter = _resolveComponent("BaseLayoutFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_BaseLayoutFooter, { showFooterMenu: _ctx.showFooterMenu }, null, 8, ["showFooterMenu"])
  ]))
}